$(function(){
pro_swatches()
  console.log('fwfewfe')
   $('.u_select_size').text($('.u_radio_btn:checked').attr('value'))
       if($('.u_radio_btn:checked').hasClass('u_stockin_size')){
       console.log('yes')
       $('.u_del_24hour_text').show()
       $('.u_del_2_10days_text').hide()
     }
     else{
              $('.u_del_2_10days_text').show()
              $('.u_del_24hour_text').hide()
     }
})
   function pro_swatches(){
            $(".u_master_select option").each(function(){
    let master =$(this);
     let master_val = $(this).attr('data-title').trim();
         let master_var_id = $(this).attr('value');
            let master_var_qty = $(this).attr('data-iq');
               let var_policy = $(this).attr('var-policy')
               let var_manag = $(this).attr('var-manag')
      $('.u_radio_btn').each(function(){
            let size = $(this).attr('value').trim()
        let combination;
            combination = size;
        console.log('combination with size',combination)
              if(master_val == combination){
                console.log('combination match')
                if(master_var_qty >= 5){
              $(this).attr('var-id',master_var_id);
            $(this).attr('var-qty',master_var_qty);
                  $(this).parent().find('input').addClass('u_stockin_size');
             $(this).parent().find('label').append(`<span class="u_vinstock_dot"></span>`);
          $(this).attr('var-policy',var_policy);
                }
                else{
            $(this).attr('var-id',master_var_id);
            $(this).attr('var-qty',master_var_qty);
                      $(this).attr('var-policy',var_policy);
                }
                }
          })
            })
   }
$(function(){
         $('.u_radio_btn').change(function(){
    console.log('fefe')
           $('.u_select_size').text($(this).attr('value'))
     if($(this).hasClass('u_stockin_size')){
       console.log('yes')
       $('.u_del_24hour_text').show()
       $('.u_del_2_10days_text').hide()
     }
     else{
              $('.u_del_2_10days_text').show()
              $('.u_del_24hour_text').hide()
     }
         })
})